import Header from './Header';
import AppLogos from './AppLogos/AppLogos';
import AppName from './AppName';
import LoginDetails from './LoginDetails';

interface HeadlineProps {
  logoUrl: string;
}

const Summary: React.FC<HeadlineProps> = () => {
  return (
    <>
      <Header />
      <AppName />
      <AppLogos />
      <LoginDetails />
    </>
  );
};

export default Summary;
